var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "#ACACAC",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04317 3.9998C4.73199 3.9998 3.66907 5.07432 3.66907 6.3998C3.66907 7.72529 4.73199 8.7998 6.04317 8.7998C7.35435 8.7998 8.41727 7.72529 8.41727 6.3998C8.41727 5.07432 7.35435 3.9998 6.04317 3.9998ZM5.2518 6.3998C5.2518 5.95798 5.60611 5.5998 6.04317 5.5998C6.48023 5.5998 6.83454 5.95798 6.83454 6.3998C6.83454 6.84163 6.48023 7.1998 6.04317 7.1998C5.60611 7.1998 5.2518 6.84163 5.2518 6.3998Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8777 0.799805C1.56652 0.799805 0.503601 1.87432 0.503601 3.1998V12.7998C0.503601 14.1253 1.56652 15.1998 2.8777 15.1998H17.1223C18.4335 15.1998 19.4964 14.1253 19.4964 12.7998V3.1998C19.4964 1.87432 18.4335 0.799805 17.1223 0.799805H2.8777ZM17.1223 2.3998H2.8777C2.44064 2.3998 2.08634 2.75798 2.08634 3.1998V12.7998C2.08634 13.2416 2.44064 13.5998 2.8777 13.5998H6.29146L11.735 8.09689C12.6621 7.15963 14.1653 7.15963 15.0925 8.09689L17.9137 10.9489V3.1998C17.9137 2.75798 17.5594 2.3998 17.1223 2.3998ZM17.1223 13.5998H8.52978L12.8542 9.22826C13.1632 8.91584 13.6643 8.91584 13.9733 9.22826L17.8401 13.1372C17.7142 13.4104 17.4401 13.5998 17.1223 13.5998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.c67e80d0e80aaeabdf37329c08af04de.svg";
export { ForwardRef as ReactComponent };